import { Checkbox } from '@mui/material';
import { styled } from "../../../styles";
export var StyledCheckbox = styled(Checkbox)(function (_ref) {
  var theme = _ref.theme;
  return "\n  padding: ".concat(theme.spacing(1), ";\n  color: ").concat(theme.palette.grey[200], ";\n");
});
export var StyledCheckboxLabel = styled.div(function (_ref2) {
  var theme = _ref2.theme;
  return "\n  font-size: 14px;\n  margin-left: ".concat(theme.spacing(2), ";\n");
});
export var StyledIconWrapperBase = styled.div(function (_ref3) {
  var theme = _ref3.theme;
  return "\n    width: ".concat(theme.spacing(3), ";\n    height: ").concat(theme.spacing(3), ";\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n  ");
});
export var StyledUncheckedIcon = styled(StyledIconWrapperBase)(function (_ref4) {
  var theme = _ref4.theme;
  return "\n    border: 2px solid ".concat(theme.palette.grey[800], ";\n    box-sizing: border-box;\n  ");
});
export var StyledCheckedIconWrapper = styled(StyledIconWrapperBase)(function (_ref5) {
  var theme = _ref5.theme;
  return "\n    background-color: ".concat(theme.palette.primary.main, ";\n  ");
});
//# sourceMappingURL=CheckboxGroup.styled.js.map